"use client";

import { c as _c } from "react/compiler-runtime";
import { Drawer, DrawerContent, useBreakpoint } from "@dc/ui/components";
import { cn } from "@dc/ui/lib/utils";
import { usePathname } from "next/navigation";
import type { FC } from "react";
import { useNotifications } from "@/hooks/useNotifications";
import type { NotificationDrawerProps } from "./NotificationDrawer.interface";
import { NotificationsPanel } from "./NotificationsPanel";
export const NotificationDrawer: FC<NotificationDrawerProps> = t0 => {
  const $ = _c(12);
  const {
    isCollapsed: t1
  } = t0;
  const isCollapsed = t1 === undefined ? false : t1;
  const {
    isOpen,
    closeDrawer
  } = useNotifications();
  const isDesktop = useBreakpoint("sm");
  const isCrunchDesktop = useBreakpoint("md");
  const pathname = usePathname();
  const isCrunchView = pathname?.includes("/crunches/") ?? false;
  if (isCrunchDesktop && isCrunchView) {
    return null;
  }
  let t2;
  if ($[0] !== closeDrawer) {
    t2 = open => {
      if (!open) {
        closeDrawer();
      }
    };
    $[0] = closeDrawer;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const onOpenChange = t2;
  const t3 = isDesktop ? "left" : "bottom";
  const t4 = isDesktop ? "sm" : "full";
  let t5;
  if ($[2] !== isCollapsed || $[3] !== isDesktop) {
    t5 = cn({
      "left-0": !isDesktop
    }, {
      "left-24": isDesktop && isCollapsed
    }, {
      "left-80": isDesktop && !isCollapsed
    });
    $[2] = isCollapsed;
    $[3] = isDesktop;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <DrawerContent><NotificationsPanel /></DrawerContent>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== isOpen || $[7] !== onOpenChange || $[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t7 = <Drawer isOpen={isOpen} onOpenChange={onOpenChange} placement={t3} size={t4} className={t5} backdrop="transparent" disableAnimation={true} hideCloseButton={true}>{t6}</Drawer>;
    $[6] = isOpen;
    $[7] = onOpenChange;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};